import React from "react";
import { Card, Col } from "react-bootstrap";
import styled from "styled-components";
import CardTitle from "../../organisms/CardTitle";
import { VentasDelMes } from "../../../services/ventasServicios";
import { formatearAnoMes } from "../../../utils/dateUtils";
import { currencyFormat } from "../../../utils/numberUtils";
import TableSection from "./TableSection";
import ResumenDeVenta from "./ResumenDeVenta";

function DetailSection({
  ventasDelMes: ventaMes,
  fechaMes,
}: {
  ventasDelMes: VentasDelMes;
  fechaMes: Date;
}) {
  const [idVentaSeleccionada, setIdVentaSeleccionada] = React.useState<
    string | undefined
  >(undefined);

  const onSeleccionarVenta = (idVenta: string) => {
    setIdVentaSeleccionada(idVenta);
  };

  const onCerrarModal = () => {
    setIdVentaSeleccionada(undefined);
  };
  return (
    <>
      <StyledCard>
        <StyledCardHeader className="mt-3">
          <Col>
            <CardTitle>{"Ventas en " + formatearAnoMes(fechaMes)}</CardTitle>
          </Col>
        </StyledCardHeader>
        <StyledCardBody>
          <div className="mb-3">
            <b>{"Total: "}</b>
            {currencyFormat(ventaMes.total)}
          </div>
          <div className="mb-3">
            <b>{"Pendiente: "}</b>
            {currencyFormat(ventaMes.totalPendiente)}
          </div>
          <TableSection
            ventas={ventaMes.ventas}
            onSeleccionarVenta={onSeleccionarVenta}
          />
        </StyledCardBody>
      </StyledCard>
      {!!idVentaSeleccionada && (
        <ResumenDeVenta
          idVenta={idVentaSeleccionada}
          onCloseClick={onCerrarModal}
        />
      )}
    </>
  );
}

const StyledCard = styled(Card)`
  margin-bottom: 1.875rem;
  background-color: #fff;
  transition: all 0.5s ease-in-out;
  position: relative;
  border: 0px solid transparent;
  border-radius: 0.25rem;
  box-shadow: 0px 0px 13px 0px rgb(82 63 105 / 5%);
`;

const StyledCardBody = styled(Card.Body)`
  padding: 1.25rem;
`;

const StyledCardHeader = styled(Card.Header)`
  border-color: #eaeaea;
  position: relative;
  background-color: inherit;
  display: flex;
  justify-content: start;
  align-items: center;
  border: 0px;
`;

export default DetailSection;
